function parseSearchParams(hash: Record<string, unknown>) {
  const params = new URLSearchParams();
  for (const key in hash) {
    let value = hash[key];
    if (!value) continue;
    if (typeof value === "object" && !Object.keys(value).length) continue;
    if (typeof value !== "string") value = JSON.stringify(value);
    params.append(key, value as string);
  }
  params.sort();
  return params;
}

export default parseSearchParams;
